import { Divider, Form, notification, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import NovoUsuario from '../../components/NovoUsuario';
import SubHeader from '../../components/SubHeader';
import apiShipper from '../../services/apiShipper';
import { Tabs } from '../../styles/global';
import ListagemUsuarios from './ListagemUsuarios';
import Monetizacao from './Monetizacao';
import Parametrizacao from './Parametrizacao';
import { Card, WrapperSpin } from './styles';

const { TabPane } = Tabs;

export default function CadastroCliente() {
  const { cnpj_resumido } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [cliente, setCliente] = useState({});
  const [isAddingNewUser, setIsAddingNewUser] = useState(false);
  const [enviandoFormulario, setEnviandoFormulario] = useState(false);

  const [currentTab, setCurrentTab] = useState(1);

  useEffect(() => {
    async function onInit() {
      if (!cnpj_resumido) return;

      let clienteApi;
      try {
        clienteApi = await apiShipper.get(`/clientes/${cnpj_resumido}`);
      } catch (e) {
        if (e.response.status === 404) {
          clienteApi = await apiShipper.get('/clientes/tmov/raiz/full-search', {
            params: {
              descricao: cnpj_resumido,
            },
          });

          const hasData =
            Object.values(clienteApi.data[0]).filter(data => data).length > 0;

          if (hasData) {
            clienteApi = await apiShipper.post('/clientes', {
              razao_social: clienteApi.data[0].razao_social,
              cnpj_resumido: clienteApi.data[0].cnpj,
              tipo: 'INTEGRACAO',
            });
          }
        } else {
          notification.error({
            message: 'Ops, não conseguimos carregar as informações do cliente.',
            description:
              'Caso o problema persista, entre em contato com nosso suporte.',
          });

          return history.push('/clientes');
        }
      }

      setCliente({
        ...clienteApi.data,
        cnpj_resumido,
        tipo: 'INTEGRACAO',
      });
    }

    onInit();
  }, [form, cnpj_resumido, history]);

  const handleAddNewUser = () => {
    setIsAddingNewUser(!isAddingNewUser);
  };

  const tabs = [
    {
      key: '1',
      title: 'Monetização',
      content: <Monetizacao cliente={cliente} />,
    },
    {
      key: '2',
      title: 'Usuários',
      content: isAddingNewUser ? (
        <NovoUsuario
          handleAddNewUser={handleAddNewUser}
          cliente={cliente}
          setEnviandoFormulario={setEnviandoFormulario}
        />
      ) : (
        <ListagemUsuarios
          cliente={cliente}
          handleAddNewUser={handleAddNewUser}
        />
      ),
    },
    {
      key: '3',
      title: 'Parametrização',
      content: <Parametrizacao cliente={cliente} />,
    },
  ];

  const breadcrumbs = [
    {
      path: '/clientes',
      breadcrumbName: 'Parametrização',
    },
    {
      breadcrumbName: cnpj_resumido
        ? 'Edição de Cliente'
        : 'Cadastro de Cliente',
    },
    {
      breadcrumbName: isAddingNewUser
        ? 'Adicionando Usuário '
        : tabs[currentTab - 1].title,
    },
  ];

  const onTabClickChange = value => setCurrentTab(Number(value));

  return (
    <>
      {enviandoFormulario ? (
        <WrapperSpin>
          <Spin
            size="large"
            className="center-loading-spin"
            message="Carregando..."
          />
        </WrapperSpin>
      ) : (
        <>
          <SubHeader breadcrumbs={breadcrumbs} />
          <Card bordered={false} className="pt-0 height-85">
            <Divider orientation="left" className="margin-divider">
              {`${cliente.razao_social} - ${cliente.cnpj_resumido}`}
            </Divider>
            <Tabs
              activeKey={currentTab.toString()}
              onTabClick={onTabClickChange}
            >
              {tabs.map(item => (
                <TabPane tab={item.title} key={item.key}>
                  {item.content}
                </TabPane>
              ))}
            </Tabs>
          </Card>
        </>
      )}
    </>
  );
}
